export const SITE = {
  name: "Brian Boland",
  fullName: "Brian Boland Psychotherapy & Counselling",
  tagline: "Counselling & Psychotherapy for Adults",
  phone: "+353 85 765 1828",
  email: "brianbolandpsychotherapy@gmail.com",
  location: "Marino, Dublin 3",
  address: "21 Fairview, Dublin 3, D03 K4H0",
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/about", label: "About", testid: "nav-link-about" },
  { to: "/therapy", label: "Therapy & Counselling", testid: "nav-link-therapy" },
  { to: "/fees-faq", label: "Fees & FAQ", testid: "nav-link-fees-faq" },
];

export const ISSUES = [
  { title: "Anxiety & stress", text: "Racing thoughts, constant worry, panic or a feeling of being always on edge." },
  { title: "Low mood & depression", text: "Heaviness, numbness, loss of motivation, or feeling disconnected from life." },
  { title: "Grief & loss", text: "Making sense of bereavement and change, at a pace that respects your loss." },
  { title: "Burnout & work pressure", text: "Exhaustion, overwhelm and the sense that there is nothing left to give." },
  { title: "Relationship difficulties", text: "Patterns in how you relate to partners, family, friends or colleagues." },
  { title: "Life transitions", text: "Separation, career change, retirement, parenthood, or simply feeling stuck." },
  { title: "Self-esteem & identity", text: "A harsh inner critic, self-doubt, or uncertainty about who you are." },
  { title: "Anger & emotional regulation", text: "Emotions that feel too big, too fast, or hard to express safely." },
];

export const STEPS = [
  {
    n: "01",
    title: "Get in touch",
    text: "Send a confidential enquiry through the booking form, by phone or by email. No referral is needed.",
  },
  {
    n: "02",
    title: "Initial consultation",
    text: "A first session to talk about what brings you to therapy and to see whether working together feels right.",
  },
  {
    n: "03",
    title: "Ongoing sessions",
    text: "Regular weekly sessions, in person in Marino or online, moving at a pace that suits you.",
  },
];

export const FAQS = [
  {
    q: "What is the difference between counselling and psychotherapy?",
    a: "The terms overlap. Counselling often focuses on a specific issue over a shorter period, while psychotherapy tends to explore deeper, longer-standing patterns. In practice, Brian works with both, shaped around what you need.",
  },
  {
    q: "How do I know if therapy is right for me?",
    a: "You do not need to be in crisis to come to therapy. Many people come because something in their life feels difficult, heavy or stuck. An initial consultation is a good, low-pressure way to find out.",
  },
  {
    q: "Is everything I say confidential?",
    a: "Yes. Sessions are confidential, with a small number of legal and ethical limits (for example, risk of serious harm), which are explained clearly at the outset.",
  },
  {
    q: "How long does a session last, and how often do we meet?",
    a: "Sessions are 50 minutes, usually once a week, at a consistent time agreed together.",
  },
  {
    q: "Can I choose between online and in-person sessions?",
    a: "Yes. You can attend in person at the practice in Marino, Dublin 3, or meet online by secure video from anywhere in the world — many clients living abroad or studying away from home choose this. Some clients combine both.",
  },
  {
    q: "How long will I need to attend?",
    a: "It varies from person to person. Some people come for a short number of sessions; others prefer longer-term work. This is reviewed together as therapy progresses.",
  },
  {
    q: "What if I need urgent help?",
    a: "This practice is not an emergency service. If you are in crisis, contact Samaritans on 116 123 (free, 24/7), your GP, or emergency services on 112 or 999.",
  },
];

export const FEES = [
  {
    title: "In-person session",
    detail: "50 minutes at the practice in Marino, Dublin 3.",
    note: "€60 per session",
  },
  {
    title: "Online session",
    detail: "50 minutes by secure video, from wherever you are in the world.",
    note: "€50 per session",
  },
  {
    title: "Low-cost options",
    detail: "The centre offers low-cost counselling options for those who need them — please ask when you enquire.",
    note: "Available through the centre",
  },
];
